import Employee from "./models/Employee"
import { getTokenRedirect } from '../authentication/PublicClientApplication'
import { IPublicClientApplication } from "@azure/msal-browser/dist/app/IPublicClientApplication"
import { AccountInfo } from "@azure/msal-common/lib/types/account/AccountInfo"

export const europeVienna = "Europe/Vienna"

export const createAuthorizationHeader = async (pca: IPublicClientApplication, account: AccountInfo): Promise<[string, string]> =>
	["Authorization", `Bearer ${(await getTokenRedirect(pca, account))}`]

export const contentTypeJson: [string, string] = ["content-type", "application/json"]

export const getSurnameFilteredEmployees = (employeeSurnameFirstLetterFilter: string, employees: readonly Employee[]) =>
	employees.filter(f => (employeeSurnameFirstLetterFilter.length > 0
		? f.Surname.charAt(0).toLowerCase() === employeeSurnameFirstLetterFilter.toLowerCase()
		: true))
